export class GuestHeaderInfo {
  RoomId: string;
  RoomTypeName : string;
  NumberOfGuests: number;
  GuestName: string;
}
